module.exports = __webpack_public_path__ + "static/media/Image-6.bddf8f69.jpg";